module.exports = __webpack_public_path__ + "img/partner_pannontakarek.adc041a0.png";